import { Box } from "@ecco/ui/box";
import dynamic from "next/dynamic";
import { memo } from "react";
import type { ProductMedia } from "@lib/product/types";

const ProductInteractiveVideo = dynamic(() => import("./ProductInteractiveVideo"), { ssr: false });
const ProductVideo = dynamic(() => import("./ProductVideo").then((mod) => mod.ProductVideo), {
    ssr: false,
});

type ProductImagesVideoProps = {
    currentlySelected: boolean;
    media: ProductMedia;
};

export const ProductImagesVideo = memo(({ currentlySelected, media }: ProductImagesVideoProps) => {
    return (
        <Box
            opacity={currentlySelected ? 1 : 0}
            key={`product-video-${media.label}`}
            position="absolute"
            top={0}
            left={0}
            aspectRatio="4/5"
            w="100%"
            transitionProperty="common"
            transitionDuration="slow"
            zIndex={currentlySelected ? 1 : 0}
        >
            {media.type === "interactiveVideo" ? (
                <ProductInteractiveVideo url={media.url} width={"100%"} />
            ) : (
                <ProductVideo productVideo={media.url} />
            )}
        </Box>
    );
});

ProductImagesVideo.displayName = "ProductImagesVideo";

export default ProductImagesVideo;
